import {
  SearchOutlined,
  DeleteOutlined,
  EditOutlined,
} from "@mui/icons-material";

import React, { useState, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Input, Popconfirm, Table, Tooltip } from "antd";
import { useGetAllUsers, useDeleteUser } from "../../../api/adduser";

const AdminStaff = () => {
  const [searchText, setSearchText] = useState("");
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(5);
  const navigate = useNavigate();
  const { mutate: deleteUser, isLoading: isDeleting } = useDeleteUser();

  const { data: users = [], isLoading } = useGetAllUsers();

  // Filtered user list based on search
  const filteredUsers = useMemo(() => {
    if (!searchText) return users;
    return users.filter(
      (user) =>
        user.firstName.toLowerCase().includes(searchText.toLowerCase()) ||
        user.lastName.toLowerCase().includes(searchText.toLowerCase()) ||
        user.email.toLowerCase().includes(searchText.toLowerCase()) ||
        user.mobile.includes(searchText)
    );
  }, [searchText, users]);

  const columns = [
    {
      title: "No.",
      render: (_, __, index) => index + 1 + (page - 1) * pageSize,
    },
    {
      title: "Name",
      render: (_, record) => (
        <span className="text-textBlack">
          {record.firstName} {record.lastName}
        </span>
      ),
    },
    {
      title: "Mobile",
      dataIndex: "mobile",
      responsive: ["md"],
    },
    {
      title: "E-Mail",
      dataIndex: "email",
      responsive: ["lg"],
    },
    {
      title: "Password",
      dataIndex: "plainPassword",
      responsive: ["xl"], // Optional: hide on smaller screens
    },
    {
      title: "Action",
      width: 200,
      render: (_, row) => (
        <div className="flex gap-8">
          {/* <Tooltip title="View User details">
            <Button
              type="default"
              icon={<RemoveRedEyeOutlined className="text-iconDefault" />}
              className="border border-borderDefault"
              onClick={() => navigate(`/user/view/${row._id}`)}
            />
          </Tooltip> */}
          <Tooltip title="Edit">
            <Button
              type="default"
              icon={<EditOutlined />}
              className="!bg-primary !border-primary text-white"
              onClick={() => navigate(`/user/edit-user/${row._id}`)}
            />
          </Tooltip>
          <Popconfirm
            title="Are you sure you want to delete this user?"
            onConfirm={() => deleteUser(row._id)}
            okText="Yes"
            cancelText="No"
          >
            <Tooltip title="Delete">
              <Button
                icon={<DeleteOutlined />}
                type="default"
                className="!bg-delete !border-delete text-white"
                loading={isDeleting}
              />
            </Tooltip>
          </Popconfirm>
        </div>
      ),
    },
  ];

  return (
    <div className="space-y-4">
      <div className="flex justify-between flex-wrap gap-4 items-center">
        <div className="relative w-80">
          <Input
            placeholder="Search..."
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
            prefix={<SearchOutlined className="text-iconDefault" />}
            className="border border-borderDefault focus:border-primary"
          />
        </div>
        <button
          onClick={() => navigate("/user/add-user")}
          className="px-6 py-2 rounded text-primary bg-primaryLight hover:bg-primary hover:text-white border border-primary transition-colors duration-300"
        >
          Add User
        </button>
      </div>

      <Table
        rowKey="_id"
        columns={columns}
        loading={isLoading}
        dataSource={filteredUsers}
        pagination={{
          current: page,
          pageSize,
          total: filteredUsers.length,
          showSizeChanger: true,
          pageSizeOptions: [5, 10, 20, 40],
          onChange: (current, size) => {
            setPage(current);
            setPageSize(size);
          },
        }}
      />
    </div>
  );
};

export default AdminStaff;
